export { ReactComponent as Link } from './svgs/link.svg';
